module.exports = {
  siteTitle: "Breachroom by Templarbit", // Site title.
  siteTitleShort: "Breachroom", // Short site title for homescreen (PWA). Preferably should be under 12 characters to prevent truncation.
  siteTitleAlt: "Breachroom by Templarbit", // Alternative site title for SEO.
  siteLogo: "/logos/logo-1024.png", // Logo used for SEO and manifest.
  siteUrl: "https://breachroom.templarbit.com/", // Domain of your website without pathPrefix.
  siteDescription: "A collection of recent cyber attacks and data breaches.", // Website description used for RSS feeds/meta description tag.
  googleAnalyticsID: "UA-98612232-6", // GA tracking ID
  copyright: `Copyright © ${new Date().getFullYear()} Templarbit Inc.`, // Copyright string for the footer of the website and RSS feed.
  themeColor: "#FF003C", // Used for setting manifest and progress theme colors.
  backgroundColor: "#FFFFFF" // Used for setting manifest background color.
};



// WEBPACK FOOTER //
// ./data/SiteConfig.js